"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svgIcons = _interopRequireDefault(require("./svgIcons"));
var _excluded = ["icon"];
var SvgIcon = function SvgIcon(_ref) {
  var icon = _ref.icon,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Icon = _svgIcons["default"][icon] || _svgIcons["default"].no_icon;
  return /*#__PURE__*/_react["default"].createElement(Icon, rest);
};
SvgIcon.propTypes = {
  icon: _propTypes["default"].oneOf(['no_icon', 'bopis', 'delivery', 'express_delivery', 'free_shipping', 'in_store', 'no_in_store', 'no_ship_to', 'ship_to']),
  disabled: _propTypes["default"].bool
};
SvgIcon.defaultProps = {
  icon: 'no_icon',
  disabled: false
};
var _default = SvgIcon;
exports["default"] = _default;
//# sourceMappingURL=SvgIcon.js.map